import classNames from 'classnames';
import * as React from 'react';


export interface ITicketButtonProps {
    onClick?: (e: React.MouseEvent) => void;
    children?: React.ReactNode;
    className?: string;
    disabled?: boolean;
    roleForTest?: string;
}

export const TicketButton: React.FC<ITicketButtonProps> = (props) => {
    return <div className={classNames("ticket-button", __IsMTSTipos__ ? "btn" : null, props.className, props.disabled ? "disabled" : null)} onClick={(e: React.MouseEvent) => { if (!props.disabled) { props.onClick(e); } }} data-test-role={props.roleForTest}>{props.children}</div>
}